import clsx from 'clsx';
import type * as React from 'react';

import { emojisByCode, getEmojiForCode } from '@gitbook/util-emojis';

// ❓
const notFoundEmojiCode = '2753';

/**
 * Render a single emoji from an UTF code.
 */
export function Emoji(props: {
    code: string;
    /**
     * Size in pixels. If null, will use font size of the parent element.
     */
    size?: number | string | null;
    className?: string;
    style?: React.CSSProperties;
}): React.ReactElement {
    const { size, className, style } = props;
    const code = emojisByCode[props.code] ? props.code : notFoundEmojiCode;
    const emoji = emojisByCode[code];
    const character = getEmojiForCode(code);
    const resolvedSize = typeof size === 'number' ? `${size / 16}rem` : size;

    return (
        <span
            className={clsx('font-emoji', className)}
            role="img"
            aria-label={emoji.name}
            style={
                resolvedSize
                    ? { fontSize: resolvedSize, lineHeight: resolvedSize, ...style }
                    : style
            }
        >
            {character}
        </span>
    );
}
